import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import MainSidebar from "components/ui/MainSidebar";
import DashboardQuickActions from "components/ui/DashboardQuickActions";
import PageTransition from "components/ui/PageTransition";
import Icon from "components/AppIcon";

import WelcomeHeader from "./components/WelcomeHeader";
import MarketSnapshot from "./components/MarketSnapshot";
import PortfolioSummary from "./components/PortfolioSummary";
import FeaturedOpportunity from "./components/FeaturedOpportunity";
import UpcomingEvents from "./components/UpcomingEvents";
import AIInsightCard from "./components/AIInsightCard";
import FounderSpotlightCarousel from "./components/FounderSpotlightCarousel";

export default function HomeDashboard() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const navigate = useNavigate();

  const sidebarWidth = sidebarCollapsed ? "64px" : "240px";

  return (
    <div
      className="min-h-screen flex"
      style={{ background: "var(--color-background)" }}
    >
      {/* Sidebar */}
      <MainSidebar
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed((p) => !p)}
      />
      {/* Main Content */}
      <main
        className={`flex-1 min-w-0 transition-all duration-250 ${sidebarCollapsed ? 'lg:ml-[64px]' : 'lg:ml-[240px]'}`}
        style={{
          paddingBottom: "80px",
        }}
      >
        {/* Sticky Top Bar (mobile spacing) */}
        <div
          className="sticky top-0 z-10 px-4 md:px-6 lg:px-8 py-3 md:py-4 lg:hidden"
          style={{
            background: "var(--color-background)",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <div className="pl-12">
            <WelcomeHeader />
          </div>
        </div>

        {/* Desktop Header */}
        <div
          className="hidden lg:block px-6 lg:px-8 py-5 lg:py-6 sticky top-0 z-10"
          style={{
            background: "var(--color-background)",
            borderBottom: "1px solid var(--color-border)",
          }}
        >
          <WelcomeHeader />
        </div>

        {/* Page Body */}
        <PageTransition>
          <div className="px-4 md:px-6 lg:px-8 py-4 md:py-6 lg:py-8">

            {/* Founding Member Banner */}
            <div
              className="card-enter card-enter-1 rounded-xl px-4 py-3 mb-5 md:mb-6 flex items-center gap-3 flex-wrap"
              style={{
                background: "linear-gradient(135deg, var(--color-primary) 0%, #2D4A87 100%)",
                border: "1px solid rgba(133,113,77,0.3)",
              }}
            >
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: "rgba(133,113,77,0.2)" }}
              >
                <Icon name="Crown" size={16} color="var(--color-accent)" strokeWidth={1.75} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-caption font-semibold text-sm text-white">
                  🎉 You&apos;re a Founding Member! Member #247 of 500
                </p>
                <p className="font-caption text-xs" style={{ color: "rgba(255,255,255,0.65)" }}>
                  Your exclusive WIN Coin keepsake is being prepared for shipment.
                </p>
              </div>
              <button
                className="btn-gold font-caption text-xs font-semibold px-3 py-1.5 rounded-lg flex-shrink-0"
                style={{ background: "var(--color-accent)", color: "var(--color-primary)" }}
                onClick={() => navigate("/members")}
              >
                View Status
              </button>
            </div>

            {/* Main Grid Layout */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">

              {/* Left Column (2/3 width on desktop) */}
              <div className="lg:col-span-2 space-y-4 md:space-y-6">
                <div className="card-enter card-enter-2">
                  <DashboardQuickActions />
                </div>
                <div className="card-enter card-enter-3">
                  <MarketSnapshot />
                </div>
                <div className="card-enter card-enter-4">
                  <PortfolioSummary />
                </div>
                <div className="card-enter card-enter-5">
                  <FeaturedOpportunity />
                </div>
              </div>

              {/* Right Column (1/3 width on desktop) */}
              <div className="space-y-4 md:space-y-6">
                <div className="card-enter card-enter-3">
                  <AIInsightCard />
                </div>
                <div className="card-enter card-enter-4">
                  <UpcomingEvents />
                </div>
              </div>
            </div>

            {/* Featured Founder Spotlight — full width below main grid */}
            <div className="card-enter card-enter-5 mt-4 md:mt-6">
              <FounderSpotlightCarousel />
            </div>

          </div>
        </PageTransition>
      </main>
    </div>
  );
}